import {
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  Text,
  useToast,
} from '@chakra-ui/react'
import { Loader } from '../../components/ComponentLoader/Loader'
import { useState } from 'react'
import { HeadingPages } from '../../components/HeadingPages'
import { Layout } from './Layout'
import { Items } from './Items'
import { EnterpriseStep } from './Steps/EnterpriseStep'
import { ConsultorStep } from './Steps/ConsultorStep'
import { InvoicingStep } from './Steps/InvoicingStep'
import { DeliveryStep } from './Steps/DeliveryStep'
import { ShippingCompanyStep } from './Steps/ShippingCompanyStep'
import { QueryErrorResetBoundary, useQuery } from 'react-query'
import { getInfoPartner, getInfoPayment } from './requests'
import { ErrorBoundary } from 'react-error-boundary'
import { AdicionarItem } from './AdicionarItem'

export function EdicaoConfirmacaoCompra() {
  const [search, setSearch] = useState('')

  const toast = useToast({
    position: 'top-right',
  })

  const { data, refetch, isLoading } = useQuery({
    queryFn: async () => {
      const [partner, payment] = await Promise.all([
        getInfoPartner(search),
        getInfoPayment(search),
      ])

      const partnerData = partner && partner.length > 0 ? partner[0] : null

      return {
        partner: partnerData,
        payment,
      }
    },
    queryKey: 'get-values',
    onError: (error) => {
      if (error.config.url.includes('itens')) {
        toast({
          title: 'Erro ao carregar dados dos itens',
          description: 'Erro ao carregar dados do parceiro',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      } else {
        toast({
          title: 'Erro ao carregar dados do parceiro',
          description: 'Erro ao carregar dados do parceiro',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }
    },
    enabled: false,
  })

  console.log('data', data)

  async function handleInfo() {
    try {
      await refetch()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <HeadingPages name="Edição Confirmação Compra" />

      {isLoading && <Loader />}

      <Flex maxW="500px" w="100%" mx="auto" gap={2} mt="1rem">
        <Input
          placeholder="Digite o número do pedido"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleInfo()}
        />
        <Button onClick={handleInfo} disabled={!search}>
          Pesquisar
        </Button>
      </Flex>

      <QueryErrorResetBoundary>
        {({ reset }) => (
          <ErrorBoundary
            onReset={reset}
            fallbackRender={({ resetErrorBoundary }) => (
              <Flex
                w="100%"
                mt="3rem"
                alignItems="center"
                justifyContent="center"
                flexDir="column"
              >
                <Text fontSize="2xl">Erro ao carregar dados</Text>
                <Button onClick={() => resetErrorBoundary()}>
                  Tentar novamente
                </Button>
              </Flex>
            )}
          >
            {data && (
              <Layout>
                <Flex>
                  <Text>
                    <strong>Número do pedido: </strong>
                  </Text>
                  <Text ml="1rem">{data?.payment[0]?.NUNOTA}</Text>
                </Flex>
                <Grid gridTemplateColumns="2.03fr 1fr" gap={4} w="100%">
                  <GridItem bg="white">
                    <EnterpriseStep
                      payment={data?.payment[0]}
                      partner={data?.partner}
                      refetch={refetch}
                    />
                  </GridItem>
                  <GridItem bg="white" position="relative">
                    <ConsultorStep
                      payment={data?.payment[0]}
                      partner={data?.partner}
                      refetch={refetch}
                    />
                  </GridItem>
                </Grid>
                <Grid gap={4} w="100%" templateColumns="repeat(3, 1fr)">
                  <GridItem bg="white">
                    <InvoicingStep
                      payment={data?.payment[0]}
                      partner={data?.partner}
                      refetch={refetch}
                    />
                  </GridItem>
                  <GridItem bg="white">
                    <DeliveryStep
                      payment={data?.payment[0]}
                      partner={data?.partner}
                      refetch={refetch}
                    />
                  </GridItem>

                  <GridItem bg="white">
                    <ShippingCompanyStep
                      payment={data?.payment[0]}
                      partner={data?.partner}
                      refetch={refetch}
                    />
                  </GridItem>
                </Grid>
                <AdicionarItem
                  item={data?.payment[0]}
                  enterprise={data?.partner}
                  refetch={refetch}
                />
                <Flex marginBlock="1rem">
                  <Items itens={data?.payment} refetch={refetch} />
                </Flex>
              </Layout>
            )}
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>
    </>
  )
}
